// AM x SD Drip Configurator
// Forked from build-a-drip.js on 2026-06-09. Reads from Shopify collection
// 'am-sd-collection' (handle); uses am_sd_collection.glb model.
// Removed from BAD: beads/chains base toggle, carabiner step, sir/sage/sapphire
// material fixes, transmission-material substitution, necklace-carabiner
// overrides. Added: collar material color override via setMaterialColor.
const AMSD_DEBUG_MODE = true;
const AMSD_COLLECTION_HANDLE = "am-sd-collection";
const AMSD_COLLAR_MATERIAL = "collar material change RGB";
// AMSD_MAX_CHARMS is declared in am-sd-drip-3d.js (loaded first) and shared
// across both files. Keeping all multi-charm tunables in the viewer file
// means there's one place to nudge during visual tuning.

function initAmSdDrip() {
  if (AMSD_DEBUG_MODE) console.log("AM x SD configurator initializing...");

  const container = document.getElementById("am-sd-drip-model-viewer");
  const modelLoader = document.getElementById("am-sd-model-loader");

  if (modelLoader) {
    modelLoader.style.display = "flex";
  }

  class AmSdDripConfigurator {
    constructor() {
      this.modelViewer = document.getElementById("am-sd-drip-model-viewer");
      this.priceElement = document.getElementById("am-sd-drip-price");
      this.priceElementMobile = document.getElementById("am-sd-drip-price-mobile");
      this.addToCartBtn = document.getElementById("am-sd-add-to-cart");
      this.mobileAddToCartBtn = document.querySelector(".am-sd-mobile-add-to-cart");
      this.shareBtn = document.getElementById("am-sd-share-config");

      this.collarOptions = document.getElementById("am-sd-collar-options");
      this.charmOptions = document.getElementById("am-sd-charm-options");
      this.collarOptionsMobile = document.getElementById("am-sd-collar-options-mobile");
      this.charmOptionsMobile = document.getElementById("am-sd-charm-options-mobile");

      const sectionEl = document.getElementById("am-sd-drip-container");
      // When true, customers can check out with 0 charms (collar-only).
      // When false, add-to-cart stays disabled until at least one charm is picked.
      this.showNoCharm = sectionEl?.dataset.showNoCharm === "true";
      this.requireFinalSaleCheckbox =
        sectionEl?.dataset.requireFinalSaleCheckbox === "true";

      this.currentOptions = { collar: null, charms: [] };
      this.productsData = { collar: [], charm: [] };

      this.basePrice = 0;
      this.currentMobileStep = 0;
      this.totalMobileSteps = 2; // 0 = collar, 1 = charm
      this.modelLoaded = false;

      this.init();
    }

    async init() {
      await this.fetchProducts();
      this.parseUrlParams();
      this.renderOptions();
      this.setupEventListeners();
      // Apply the resolved selection (from URL or defaults) to the 3D model.
      // If the model is already loaded, this paints the correct collar color
      // and charm immediately. If the model isn't loaded yet, updateModel
      // returns early; the bootstrap "am-sd-model-loaded" listener will then
      // run updateModel against the now-populated currentOptions.
      this.updateModel();
      this._updateAddToCartDisabled();
      if (AMSD_DEBUG_MODE) console.log("AM x SD configurator initialized");
    }

    async fetchProducts() {
      try {
        const variantMetafieldsScript = document.getElementById("am-sd-drip-variants");
        let variantMetafields = {};
        if (variantMetafieldsScript) {
          try {
            variantMetafields = JSON.parse(variantMetafieldsScript.textContent);
          } catch (e) {
            console.error("Failed to parse am-sd variant metafields JSON:", e);
          }
        }

        const response = await fetch(
          `/collections/${AMSD_COLLECTION_HANDLE}/products.json`
        );
        const data = await response.json();

        const isLocalEnv =
          window.location.hostname === "localhost" ||
          window.location.hostname === "127.0.0.1";

        data.products.forEach((product) => {
          const productType = this.getProductType(product);
          if (!productType) return;

          product.variants.forEach((variant) => {
            const variantId = String(variant.id);
            const meta = variantMetafields[variantId] || {};

            if (
              !isLocalEnv &&
              (meta.hidden_on_new_site === true ||
                meta.hidden_on_new_site === "true")
            ) {
              return;
            }

            const nodeId = meta.node_id || "";
            const colorName = meta.color_name || variant.title;
            const collarHex = meta.collar_hex || null;
            const thumbImage =
              meta.image ||
              (variant.featured_image ? variant.featured_image.src : null);
            const otherThumbImage = meta.other_thumb
              ? `https:${meta.other_thumb}`
              : null;

            this.productsData[productType].push({
              id: variant.id,
              productId: product.id,
              title: variant.title,
              colorName: colorName,
              nodeId: nodeId,
              collarHex: collarHex,
              price: parseFloat(variant.price),
              image: thumbImage,
              otherThumbImage: otherThumbImage,
              available: variant.available,
              sku: variant.sku,
            });
          });
        });

      } catch (error) {
        console.error("Error fetching AM x SD products:", error);
      }
    }

    getProductType(product) {
      const title = (product.title || "").toLowerCase();
      if (title.includes("collar")) return "collar";
      if (title.includes("charm")) return "charm";
      return null;
    }

    parseUrlParams() {
      const urlParams = new URLSearchParams(window.location.search);
      const collarParam = urlParams.get("collar");
      const charmParam = urlParams.get("charm");

      const collarOption = collarParam
        ? this.productsData.collar.find(
            (opt) => opt.id.toString() === collarParam || opt.sku === collarParam
          )
        : null;
      this.currentOptions.collar =
        collarOption ||
        this.productsData.collar.find((opt) => opt.available) ||
        this.productsData.collar[0];

      if (charmParam) {
        const ids = charmParam.split(",").filter(Boolean);
        this.currentOptions.charms = ids
          .map((id) =>
            this.productsData.charm.find(
              (opt) => opt.id.toString() === id || opt.sku === id,
            ),
          )
          .filter(
            (opt) =>
              opt && opt.id !== "no-charm" && opt.available,
          )
          .slice(0, AMSD_MAX_CHARMS);
      } else {
        this.currentOptions.charms = [];
      }
    }

    renderOptions() {
      this.renderProductOptions(this.collarOptions, this.productsData.collar, "collar", true);
      this.renderProductOptions(this.charmOptions, this.productsData.charm, "charm", false);
      if (this.collarOptionsMobile) {
        this.renderProductOptions(this.collarOptionsMobile, this.productsData.collar, "collar", true);
      }
      if (this.charmOptionsMobile) {
        this.renderProductOptions(this.charmOptionsMobile, this.productsData.charm, "charm", false);
      }
      this.updateUISelections();
      this.updateTotalPrice();
    }

    renderProductOptions(container, options, optionType, isColorOption) {
      if (!container) return;
      container.innerHTML = "";

      const sortedOptions = [...options].sort((a, b) => {
        if (a.available && !b.available) return -1;
        if (!a.available && b.available) return 1;
        return 0;
      });

      sortedOptions.forEach((option) => {
        const el = document.createElement("div");
        el.className = isColorOption
          ? "option-item color-option"
          : "option-item charm-option";
        el.dataset.optionId = option.id;
        el.dataset.optionType = optionType;
        el.dataset.nodeId = option.nodeId || "";

        if (!option.available) {
          el.classList.add("option-unavailable");
          const soldOutLabel = document.createElement("div");
          soldOutLabel.className = "sold-out-label";
          soldOutLabel.textContent = "Sold Out";
          el.appendChild(soldOutLabel);
        }

        if (isColorOption) {
          // Collar swatch — solid color fill from collar_hex metafield.
          // If a thumbnail image exists, prefer it.
          const isMobile = container.id && container.id.includes("-mobile");
          const wrapperSize = isMobile ? "40px" : "34px";
          const wrapper = document.createElement("div");
          wrapper.style.width = wrapperSize;
          wrapper.style.height = wrapperSize;
          wrapper.style.borderRadius = "50%";
          wrapper.style.overflow = "hidden";
          wrapper.style.display = "block";

          if (option.image) {
            const img = document.createElement("img");
            img.src = option.otherThumbImage || option.image;
            img.alt = option.colorName || option.title;
            img.className = "color-option-image";
            img.loading = "lazy";
            img.decoding = "async";
            wrapper.appendChild(img);
          } else if (option.collarHex) {
            wrapper.style.backgroundColor = option.collarHex;
          }
          el.appendChild(wrapper);
          el.title = option.colorName || option.title;

          // Hover preview — replace the collar name with "<Name> ($XX.XX)"
          // while the cursor is over the tile; restore the currently
          // selected collar's name on mouseleave.
          el.addEventListener("mouseenter", () => {
            const text = `${option.colorName || option.title} (${this.formatPrice(option.price || 0)})`;
            const nameEl = document.getElementById(
              "am-sd-collar-selected-name",
            );
            const nameElMobile = document.getElementById(
              "am-sd-collar-selected-name-mobile",
            );
            if (nameEl) nameEl.textContent = text;
            if (nameElMobile) nameElMobile.textContent = text;
          });
          el.addEventListener("mouseleave", () => {
            const collar = this.currentOptions.collar;
            if (!collar) return;
            const name = collar.colorName || collar.title;
            const nameEl = document.getElementById(
              "am-sd-collar-selected-name",
            );
            const nameElMobile = document.getElementById(
              "am-sd-collar-selected-name-mobile",
            );
            if (nameEl) nameEl.textContent = name;
            if (nameElMobile) nameElMobile.textContent = name;
          });
        } else {
          // Charm tile
          if (option.image) {
            const img = document.createElement("img");
            img.src = option.image;
            img.alt = option.colorName || option.title;
            img.className = "charm-image";
            img.loading = "lazy";
            img.decoding = "async";
            el.appendChild(img);
          } else {
            // No thumbnail uploaded yet — fill the tile with the spicy dan
            // brand green so it reads as an intentional placeholder rather
            // than an empty slot. The merchant can still upload a thumbnail
            // later and the configurator will pick it up via the metafield.
            el.classList.add("charm-no-thumb");
          }
          el.title = option.colorName || option.title;

          // Position badge — shows the charm's slot index when selected.
          const badge = document.createElement("span");
          badge.className = "charm-position-badge";
          el.appendChild(badge);

          // Hover preview — replace the "X / 5 selected" counter with the
          // hovered charm's name + price while the cursor is over the tile;
          // restore the counter on mouseleave.
          el.addEventListener("mouseenter", () => {
            const text = `${option.colorName || option.title} (${this.formatPrice(option.price || 0)})`;
            const counterEl = document.getElementById("am-sd-charm-counter");
            const counterElMobile = document.getElementById(
              "am-sd-charm-counter-mobile",
            );
            if (counterEl) counterEl.textContent = text;
            if (counterElMobile) counterElMobile.textContent = text;
          });
          el.addEventListener("mouseleave", () => {
            this.updateCharmCounter();
          });
        }

        const isSelected =
          optionType === "charm"
            ? (this.currentOptions.charms || []).some(
                (c) => c.id === option.id,
              )
            : this.currentOptions.collar?.id === option.id;
        if (isSelected) el.classList.add("selected");

        el.addEventListener("click", () => {
          if (!option.available) return;
          this.selectOption(optionType, option);
        });

        container.appendChild(el);
      });
    }

    selectOption(optionType, option) {
      if (optionType === "charm") {
        const charms = this.currentOptions.charms || [];
        const idx = charms.findIndex((c) => c.id === option.id);
        if (idx >= 0) {
          // Toggle off
          charms.splice(idx, 1);
        } else {
          if (charms.length >= AMSD_MAX_CHARMS) return; // Cap reached
          charms.push(option);
        }
        this.currentOptions.charms = charms;
      } else {
        this.currentOptions[optionType] = option;
      }

      // Refresh the .selected class on every tile of this type.
      document
        .querySelectorAll(`.option-item[data-option-type="${optionType}"]`)
        .forEach((item) => {
          const id = item.dataset.optionId;
          let isSelected;
          if (optionType === "charm") {
            isSelected = (this.currentOptions.charms || []).some(
              (c) => c.id.toString() === id,
            );
          } else {
            isSelected =
              this.currentOptions[optionType]?.id.toString() === id;
          }
          item.classList.toggle("selected", isSelected);
        });

      if (optionType === "collar") {
        const displayName = option.colorName || option.title;
        const nameEl = document.getElementById("am-sd-collar-selected-name");
        const nameElMobile = document.getElementById(
          "am-sd-collar-selected-name-mobile",
        );
        if (nameEl) nameEl.textContent = displayName;
        if (nameElMobile) nameElMobile.textContent = displayName;
      } else {
        this.updateCharmCounter();
        this._updateCharmBadges();
        this._updateAtMaxState();
      }

      this.updateModel();
      this.updateTotalPrice();
      this.updateShareableUrl();

      // Snap the camera back to the front so the new selection is presented
      // head-on regardless of how the user has rotated the model.
      window.amSdModelViewer?.resetCameraView?.(600);

      this._updateAddToCartDisabled();
    }

    updateUISelections() {
      // Collar — single-select, name shown
      const collar = this.currentOptions.collar;
      if (collar) {
        document
          .querySelectorAll(
            `.option-item[data-option-type="collar"][data-option-id="${collar.id}"]`,
          )
          .forEach((el) => el.classList.add("selected"));
        const name = collar.colorName || collar.title;
        const nameEl = document.getElementById("am-sd-collar-selected-name");
        const nameElMobile = document.getElementById(
          "am-sd-collar-selected-name-mobile",
        );
        if (nameEl) nameEl.textContent = name;
        if (nameElMobile) nameElMobile.textContent = name;
      }

      // Charm — multi-select. Mark each selected tile and update the counter.
      const charms = this.currentOptions.charms || [];
      document
        .querySelectorAll(`.option-item[data-option-type="charm"]`)
        .forEach((el) => {
          const id = el.dataset.optionId;
          const selected = charms.some((c) => c.id.toString() === id);
          el.classList.toggle("selected", selected);
        });
      this.updateCharmCounter();
      this._updateCharmBadges();
      this._updateAtMaxState();
    }

    updateCharmCounter() {
      const count = this.currentOptions.charms?.length ?? 0;
      const text = `${count} / ${AMSD_MAX_CHARMS} selected`;
      const nameEl = document.getElementById("am-sd-charm-counter");
      const nameElMobile = document.getElementById("am-sd-charm-counter-mobile");
      if (nameEl) nameEl.textContent = text;
      if (nameElMobile) nameElMobile.textContent = text;
    }

    _updateCharmBadges() {
      const charms = this.currentOptions.charms || [];
      const idToIndex = new Map(
        charms.map((c, i) => [c.id.toString(), i + 1]),
      );
      document
        .querySelectorAll(`.option-item[data-option-type="charm"]`)
        .forEach((el) => {
          const id = el.dataset.optionId;
          const badge = el.querySelector(".charm-position-badge");
          if (!badge) return;
          const idx = idToIndex.get(id);
          badge.textContent = idx ? String(idx) : "";
        });
    }

    _updateAtMaxState() {
      const charms = this.currentOptions.charms || [];
      const atMax = charms.length >= AMSD_MAX_CHARMS;
      document
        .querySelectorAll(`.option-item[data-option-type="charm"]`)
        .forEach((el) => {
          const id = el.dataset.optionId;
          const option = this.productsData.charm.find(
            (o) => o.id.toString() === id,
          );
          if (!option) return;
          const isSelected = charms.some((c) => c.id.toString() === id);
          // Sold-out trumps at-max — keep option-unavailable on sold-out tiles
          // regardless. For in-stock tiles, toggle option-unavailable purely on
          // the (atMax && !isSelected) condition.
          if (!option.available) {
            el.classList.add("option-unavailable");
          } else {
            el.classList.toggle(
              "option-unavailable",
              atMax && !isSelected,
            );
          }
        });
    }

    updateTotalPrice() {
      let total = this.basePrice;
      if (this.currentOptions.collar) {
        total += this.currentOptions.collar.price || 0;
      }
      for (const charm of this.currentOptions.charms || []) {
        total += charm.price || 0;
      }
      const formatted = this.formatPrice(total);
      if (this.priceElement) this.priceElement.textContent = formatted;
      if (this.priceElementMobile) this.priceElementMobile.textContent = formatted;
    }

    formatPrice(price) {
      // Match BAD's default $ prefix; full multi-currency handling can be ported
      // from build-a-drip.js if/when Shopify currency switching is enabled here.
      return "$" + price.toFixed(2);
    }

    _updateAddToCartDisabled() {
      const requireCheckbox = this.requireFinalSaleCheckbox;

      const charmsOk =
        this.showNoCharm || (this.currentOptions.charms || []).length > 0;

      const finalSaleCheckbox = document.getElementById(
        "am-sd-final-sale-checkbox",
      );
      const finalSaleCheckboxMobile = document.getElementById(
        "am-sd-final-sale-checkbox-mobile",
      );
      const checkboxOk =
        !requireCheckbox ||
        finalSaleCheckbox?.checked ||
        finalSaleCheckboxMobile?.checked;

      const disabled = !(charmsOk && checkboxOk);
      if (this.addToCartBtn) {
        this.addToCartBtn.disabled = disabled;
        this.addToCartBtn.style.cursor = disabled ? "not-allowed" : "pointer";
      }
      if (this.mobileAddToCartBtn) {
        this.mobileAddToCartBtn.disabled = disabled;
        this.mobileAddToCartBtn.style.cursor = disabled
          ? "not-allowed"
          : "pointer";
      }
    }

    updateShareableUrl() {
      const params = new URLSearchParams();
      if (this.currentOptions.collar) {
        params.set("collar", this.currentOptions.collar.id);
      }
      const charms = this.currentOptions.charms || [];
      if (charms.length > 0) {
        params.set("charm", charms.map((c) => c.id).join(","));
      }
      const qs = params.toString();
      const newUrl = qs
        ? `${window.location.pathname}?${qs}`
        : window.location.pathname;
      window.history.replaceState({}, "", newUrl);
    }

    updateModel() {
      if (!window.amSdModelViewer) {
        window.addEventListener("am-sd-model-loaded", () => this.updateModel(), { once: true });
        return;
      }
      if (!window.amSdModelViewer.model) return;

      // Collar: always visible; recolor the enamel material instead.
      if (this.currentOptions.collar && this.currentOptions.collar.collarHex) {
        window.amSdModelViewer.setMaterialColor(
          AMSD_COLLAR_MATERIAL,
          this.currentOptions.collar.collarHex
        );
      }

      // Collar mesh is always visible; setupModel hides everything by default,
      // so we have to explicitly show it.
      const collarNode = window.amSdModelViewer.model.getObjectByName("Collar");
      if (collarNode) {
        collarNode.visible = true;
        collarNode.traverse((c) => { c.visible = true; });
      }

      // Charm: render the selected list via the multi-charm helper.
      window.amSdRenderCharms(this.currentOptions.charms || []);
    }

    addToCart() {
      const missing = [];
      if (!this.currentOptions.collar) missing.push("Collar");
      if (missing.length > 0) {
        alert(`Please select: ${missing.join(", ")}`);
        return;
      }

      const charms = this.currentOptions.charms || [];
      if (!this.showNoCharm && charms.length === 0) {
        alert("Please select at least one charm.");
        return;
      }

      const bundleId = `am-sd-drip-${Date.now()}`;
      const items = [];

      const collar = this.currentOptions.collar;
      items.push({
        id: collar.id,
        properties: {
          "Bundle Group": bundleId,
          Component: "Collar",
          Color: collar.colorName || collar.title,
        },
      });

      for (const charm of charms) {
        items.push({
          id: charm.id,
          properties: {
            "Bundle Group": bundleId,
            Component: "Charm",
            Color: charm.colorName || charm.title,
          },
        });
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      })
        .then((r) => {
          if (!r.ok) throw new Error("Network error");
          return r.json();
        })
        .then(() => {
          if (typeof window.updateCartUI === "function") window.updateCartUI();
          this.showConfirmation();
        })
        .catch((err) => {
          console.error("AM x SD add-to-cart error:", err);
          alert("There was an error adding this bundle to your cart.");
        });
    }

    showConfirmation() {
      const configurator = document.querySelector(".am-sd-configurator");
      const confirmation = document.getElementById("am-sd-drip-confirmation-content");
      if (configurator && confirmation) {
        configurator.classList.add("hidden");
        confirmation.classList.remove("hidden");
        confirmation.classList.add("flex");
      }
    }

    shareConfiguration() {
      const shareUrl = window.location.href;
      navigator.clipboard
        .writeText(shareUrl)
        .then(() => alert("Configuration URL copied to clipboard!"))
        .catch(() => alert("The URL for this configuration is: " + shareUrl));
    }

    setupMobileNavigation() {
      const prevBtn = document.getElementById("am-sd-mobile-prev-option");
      const nextBtn = document.getElementById("am-sd-mobile-next-option");
      if (!prevBtn || !nextBtn) return;

      const totalSteps = this.totalMobileSteps;
      const update = (step) => {
        document
          .querySelectorAll(".am-sd-mobile-option-group")
          .forEach((g) => g.classList.remove("active"));
        document
          .querySelectorAll(`.am-sd-mobile-option-group[data-step="${step}"]`)
          .forEach((g) => g.classList.add("active"));
        prevBtn.disabled = step === 0;
        nextBtn.disabled = step === totalSteps - 1;
        this.currentMobileStep = step;
      };

      prevBtn.addEventListener("click", (e) => {
        e.preventDefault();
        if (this.currentMobileStep > 0) update(this.currentMobileStep - 1);
      });
      nextBtn.addEventListener("click", (e) => {
        e.preventDefault();
        if (this.currentMobileStep < totalSteps - 1) update(this.currentMobileStep + 1);
      });
      update(0);
    }

    setupEventListeners() {
      const requireCheckbox = this.requireFinalSaleCheckbox;

      if (this.addToCartBtn) {
        this.addToCartBtn.addEventListener("click", () => this.addToCart());
      }
      if (this.mobileAddToCartBtn) {
        this.mobileAddToCartBtn.addEventListener("click", () =>
          this.addToCart(),
        );
      }

      const finalSaleCheckbox = document.getElementById(
        "am-sd-final-sale-checkbox",
      );
      if (finalSaleCheckbox && requireCheckbox) {
        finalSaleCheckbox.addEventListener("change", () =>
          this._updateAddToCartDisabled(),
        );
      }
      const finalSaleCheckboxMobile = document.getElementById(
        "am-sd-final-sale-checkbox-mobile",
      );
      if (finalSaleCheckboxMobile && requireCheckbox) {
        finalSaleCheckboxMobile.addEventListener("change", () =>
          this._updateAddToCartDisabled(),
        );
      }

      if (this.shareBtn) {
        this.shareBtn.addEventListener("click", () => this.shareConfiguration());
      }

      this.setupMobileNavigation();
    }
  }

  // Global helper used by the configurator's updateModel. Multi-charm
  // rendering (Approach A: move-and-reveal): hide every charm subtree, then
  // for each entry in charmList reset its local transform from the pristine
  // snapshot captured at load and apply the slot transform. Mutations of
  // child.position/.quaternion never compound because we always re-derive
  // from the pristine map.
  window.amSdRenderCharms = function (charmList) {
    const viewer = window.amSdModelViewer;
    if (!viewer || !viewer.model) return;

    hideAllCharmSubtrees(viewer);

    if (!Array.isArray(charmList) || charmList.length === 0) return;

    const n = Math.min(charmList.length, AMSD_MAX_CHARMS);
    const slots = viewer.computeSlotTransforms(n);
    if (slots.length !== n) {
      if (AMSD_DEBUG_MODE)
        console.warn(
          "[AmSdDrip] computeSlotTransforms returned wrong length; skipping render",
          { n, got: slots.length },
        );
      return;
    }

    for (let i = 0; i < n; i++) {
      const charm = charmList[i];
      if (!charm || !charm.nodeId) continue;
      const node = findNode(viewer.model, charm.nodeId);
      if (!node) {
        if (AMSD_DEBUG_MODE)
          console.warn(`[AmSdDrip] charm node not found: ${charm.nodeId}`);
        continue;
      }
      applySlotTransform(viewer, node, slots[i]);
      setSubtreeVisible(node, true);
      let p = node.parent;
      while (p) {
        p.visible = true;
        p = p.parent;
      }
    }
  };

  function hideAllCharmSubtrees(viewer) {
    if (!viewer || !viewer.model) return;
    viewer.model.traverse((node) => {
      if (!node.name) return;
      if (node.name === "Collar" || node.name === "Empty") return;
      if (node.parent && node.parent.name === "Empty") {
        node.visible = false;
      }
    });
  }

  function applySlotTransform(viewer, node, slot) {
    const pristine = viewer._charmPristine?.get(node.name);
    if (!pristine) return;

    // Start from the pristine local transform — all subsequent edits are
    // deltas on top of this, so mutations across calls never compound.
    node.position.copy(pristine.position);
    node.quaternion.copy(pristine.quaternion);
    node.scale.copy(pristine.scale);

    if (node.parent) node.parent.updateMatrixWorld(true);

    // Translation: move this charm so its hook (its own per-charm pristine
    // top point in the upDir direction, computed at load time) ends up at
    // slot.attach. World-space delta is slot.attach - pristine.hookWorld;
    // because we preserve the pristine local position the rest of the charm
    // body follows along.
    if (pristine.hookWorld) {
      const worldDelta = new THREE.Vector3().subVectors(
        slot.attach,
        pristine.hookWorld,
      );
      const localDelta = worldDelta.clone();
      if (node.parent) {
        const parentQuatInv = new THREE.Quaternion();
        node.parent.getWorldQuaternion(parentQuatInv).invert();
        localDelta.applyQuaternion(parentQuatInv);
      }
      node.position.add(localDelta);
    } else if (node.parent) {
      // Fallback (shouldn't happen): just place the node origin at slot.worldPos.
      const localTarget = node.parent.worldToLocal(slot.worldPos.clone());
      node.position.copy(localTarget);
    }

    // Rotation: apply a world-space rotation around the collar's axis by
    // slot.theta when tangent mode is on. Transform the collar axis into the
    // parent's local frame, then PRE-multiply onto the local quaternion —
    // post-multiplying rotates in the node's own local frame, which gives
    // the wrong result when the charm has its own pristine orientation.
    if (AMSD_CHARM_TANGENT_ROTATION && slot.theta !== 0) {
      const axis = viewer._collarAxis
        ? viewer._collarAxis.clone()
        : new THREE.Vector3(0, 1, 0);
      if (node.parent) {
        const parentQuatInv = new THREE.Quaternion();
        node.parent.getWorldQuaternion(parentQuatInv).invert();
        axis.applyQuaternion(parentQuatInv).normalize();
      }
      const rot = new THREE.Quaternion().setFromAxisAngle(axis, slot.theta);
      node.quaternion.premultiply(rot);
    }

    node.updateMatrixWorld(true);
  }

  function findNode(root, name) {
    // Exact match first
    let found = root.getObjectByName(name);
    if (found) return found;
    // Three.js GLTFLoader runs THREE.PropertyBinding.sanitizeNodeName on each
    // node name when loading, which (a) replaces all whitespace with "_" and
    // (b) strips reserved characters [ ] . : / from the name. So a metafield
    // node_id of "B/W Pepper charm" becomes "BW_Pepper_charm" in Three.js.
    const sanitized = name.replace(/\s/g, "_").replace(/[\[\].:\/]/g, "");
    if (sanitized !== name) {
      found = root.getObjectByName(sanitized);
      if (found) return found;
    }
    // Case-insensitive fallback against both forms.
    const lower = name.toLowerCase();
    const lowerSan = sanitized.toLowerCase();
    root.traverse((n) => {
      if (found || !n.name) return;
      const candidate = n.name.toLowerCase();
      if (candidate === lower || candidate === lowerSan) found = n;
    });
    return found;
  }

  function setSubtreeVisible(node, visible) {
    node.visible = visible;
    node.traverse((c) => {
      c.visible = visible;
    });
  }

  // Bootstrap configurator + viewer
  if (!window.amSdDripConfigurator) {
    window.amSdDripConfigurator = new AmSdDripConfigurator();
  }

  if (container && !window.amSdModelViewer) {
    let modelLoadHandled = false;
    window.addEventListener(
      "am-sd-model-loaded",
      () => {
        if (modelLoadHandled) return;
        modelLoadHandled = true;
        try {
          window.amSdDripConfigurator?.updateModel();
        } catch (e) {
          console.error("[AmSdDrip] updateModel error:", e);
        } finally {
          if (modelLoader) modelLoader.style.display = "none";
        }
      },
      { once: true }
    );

    window.amSdModelViewer = new AmSdDripModelViewer(
      "am-sd-drip-model-viewer",
      "am_sd_collection.glb"
    );

    // Cached-model fallback
    setTimeout(() => {
      if (window.amSdModelViewer?.model && !modelLoadHandled) {
        modelLoadHandled = true;
        try {
          window.amSdDripConfigurator?.updateModel();
        } catch (e) {
          console.error("[AmSdDrip] updateModel error:", e);
        } finally {
          if (modelLoader) modelLoader.style.display = "none";
        }
      }
    }, 100);
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAmSdDrip);
} else {
  initAmSdDrip();
}
